/** @jsx jsx */
import { jsx } from '@emotion/react';

function SkillSetIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="32" fill="none" viewBox="0 0 27 32">
      <path fill="#fff" d="M.996 23.198V8.54l12.012-7.328 12.012 7.33v14.656l-12.012 7.328L.996 23.198z" />
      <path
        fill="#EBA600"
        fillRule="evenodd"
        d="M0 7.935L13.006 0 26 7.935v15.871l-12.994 7.935L0 23.803V7.935zm24.018 1.212l-11.012-6.72-11.012 6.72v13.444l11.012 6.723 11.012-6.72V9.147z"
        clipRule="evenodd"
      />
      <path
        fill="#FFC500"
        d="M24.019 9.164l1.994-1.228v15.87l-1.997-1.218.003-13.424zM0 23.803l1.973-1.225 11.052 6.743-.019 2.417L0 23.803zM1.982 9.144L0 7.935 13.006 0l-.012 2.408L1.982 9.144z"
      />
      <path
        fill="#FFC500"
        stroke="#EBA600"
        strokeLinecap="round"
        strokeWidth="1.616"
        d="M13.006 9.458l1.97 4.221 4.41.676-3.19 3.287.752 4.639-3.942-2.189-3.943 2.189.752-4.639-3.19-3.287 4.408-.676 1.973-4.221z"
      />
    </svg>
  );
}

export default SkillSetIcon;
